import { defineComponent as _defineComponent } from 'vue'


interface Props {
	/**
	 * 「他返信時表示」文言
	 */
	replyMoreDisplayText: string;
	/**
	 * リプライ総件数。
	 */
	replyCount: number;
	/**
	 * リプライの追加表示APIリクエスト中かどうか。
	 */
	isProcessingGetMoreReply: boolean;
}
interface Emits {
	(e: "on-click-more-button"): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    replyMoreDisplayText: { type: String, required: true },
    replyCount: { type: Number, required: true },
    isProcessingGetMoreReply: { type: Boolean, required: true }
  },
  emits: ["on-click-more-button"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: "on-click-more-button"): void;
}), expose: any, slots: any, attrs: any }) {
  expose()

const props = __props as {
	/**
	 * 「他返信時表示」文言
	 */
	replyMoreDisplayText: string;
	/**
	 * リプライ総件数。
	 */
	replyCount: number;
	/**
	 * リプライの追加表示APIリクエスト中かどうか。
	 */
	isProcessingGetMoreReply: boolean;
}
/**
 * リプライ総数。
 */




const onclick = (): void => {
	emit("on-click-more-button");
};

/**
 * 表示文言。
 */
let displayText = props.replyMoreDisplayText.replace("${count}", props.replyCount.toString());

/**
 * 他返信があるかどうか。
 */
const isExistOtherReply = (): boolean => {
	return props.replyCount !== 0;
};

const __returned__ = { props, emit, onclick, displayText, isExistOtherReply }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})